import { communeApi, districtApi, popularPlaceApi, propertyTypeApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { searchActions } from "./actions";

export function* searchSaga() {
    yield takeEveryFsa(searchActions.getCommunes.started, function* (action) {
        yield* makeAsyncApiCall(action, searchActions.getCommunes, communeApi)
    });

    yield takeEveryFsa(searchActions.getDistricts.started, function* (action) {
        yield* makeAsyncApiCall(action, searchActions.getDistricts, districtApi)
    });

    yield takeEveryFsa(searchActions.getPopularPlaces.started, function* (action) {
        yield* makeAsyncApiCall(action, searchActions.getPopularPlaces, popularPlaceApi)
    });

    yield takeEveryFsa(searchActions.getPropertTypes.started, function* (action) {
        yield* makeAsyncApiCall(action, searchActions.getPropertTypes, propertyTypeApi)
    })
}